import React from "react";
import Container from "src/components/common/Layout/Container";
import { colors } from "src/config/colors";
import FeedbackForm from "src/components/Feedback/components/FeedbackForm";
import { Typography } from "@mui/material";

const FeedbackPage: React.FC = () => {
  return (
    <Container isWithPaper paddingTop={3} paddingBottom={3} paddingX={1.5}>
      <Typography
        component="h1"
        fontSize={20}
        color={colors.darkBlue}
        lineHeight="30px"
        fontWeight={550}
        marginBottom={1}
      >
        Обратная связь
      </Typography>
      <Typography
        component="p"
        fontSize={16}
        lineHeight="25px"
        fontWeight={400}
        marginBottom={2}
      >
        Напишите на почту {process.env.FEEDBACK_MAIL} или заполните форму, и Вам
        ответят в ближайшее время
      </Typography>
      <FeedbackForm />
    </Container>
  );
};

export default FeedbackPage;
